import React from "react";
import { Outlet } from "react-router-dom";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

import { CssBaseline } from "@mui/material";
import GlobalStyle from "../components/GlobalStyle";
import {
  oneSolomonColors,
  OneSolomonPageBackground,
  useIsCompanyOneSolomonsFromSearch,
} from "../pages/order/oneSolomonUi";

const Root = styled.div<{ $oneSolomon?: boolean }>`
  max-width: 520px;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  display: flex;
  min-height: 100%;
  flex-direction: column;

  ${({ $oneSolomon }) =>
    $oneSolomon &&
    css`
      max-width: none;
      width: 100%;
      background: ${oneSolomonColors.oldWhite};
      min-height: 100vh;
    `}
`;

interface LayoutType {
  children?: React.ReactNode;
}

const Layout: React.FC<LayoutType> = ({ children }) => {
  const isCompanyOneSolomons = useIsCompanyOneSolomonsFromSearch();

  return (
    <Root $oneSolomon={isCompanyOneSolomons}>
      <CssBaseline />
      <GlobalStyle />
      {isCompanyOneSolomons && <OneSolomonPageBackground />}
      {children}
      <Outlet />
      {/*<Settings />*/}
    </Root>
  );
};

export default Layout;
